export default "__VITE_ASSET__CWZOO3Vf__"